/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SendPatientSignatureRequestMessage from 'DesignSystem/SendPatientSignatureRequestMessage/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content/Content/Content/Footer/SendForSignatureAction/Empty/RequestAction/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'id',
})
let patientPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person.id',
})
let constantData = ' '
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
let onSubmitPre = fromHelpers.useOnSubmitPre({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SendPatientSignatureRequestMessage
  viewPath={`${viewPath}/SendPatientSignatureRequestMessage`}
 data="patient.id"
 patientId={patientIdValueData}
 data="patient.person.id"
 personId={patientPersonIdValueData}
 onSubmit={onSubmit}
 onSubmitPre={onSubmitPre}
 data="' '"
 message={constantData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 includeProfessionals={true}
 includeExternalProfessionals={true}
/>
{children}
</React.Fragment>)
}